import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propAny, propBool, propChildren, propFunc, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import GoodIcon from '../../../../../../Icon/Svg/GoodIcon';
import MoneyCircleIcon from '../../../../../../Icon/Svg/MoneyCircleIcon';
const InterviewFilterSelectControl = (props) => {
    const { children, cx, getStyles, getValue, innerProps, innerRef, isDisabled, isFocused, menuIsOpen, } = props;
    const data = getValue()[0];
    return (_jsxs("div", Object.assign({ className: cx({
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen,
        }), ref: innerRef, style: getStyles('control', props) }, innerProps, { children: [data.value === 'charm_point' && _jsx(GoodIcon, {}), data.value === 'price' && _jsx(MoneyCircleIcon, {}), children] })));
};
InterviewFilterSelectControl.propTypes = {
    children: propChildren().isRequired,
    className: propStr(),
    cx: propFunc().isRequired,
    getStyles: propFunc().isRequired,
    getValue: propFunc().isRequired,
    innerProps: propShape().isRequired,
    innerRef: propAny(),
    isDisabled: propBool().isRequired,
    isFocused: propBool().isRequired,
    menuIsOpen: propBool().isRequired,
};
InterviewFilterSelectControl.defaultProps = {
    className: '',
    innerRef: null,
};
export default InterviewFilterSelectControl;
